import { ApolloClient } from '@apollo/client';
import createAnalyticsEvent from './mutations/createAnalyticsEvent.graphql';
import getWindowUrl from './getWindowUrl.mjs';
import { Job } from './graphql/api/graphql';

type TrackerJob = Partial<
  Pick<Job, '_id' | 'city' | 'id' | 'title'>
> & {
  company?: Partial<Pick<Job['company'], 'displayName' | 'name'>>;
};

const getJobEventTracker = (
  client: ApolloClient<unknown>,
  category: string,
  job: TrackerJob | null | undefined,
  eventType = 'CLICK',
) => async () => {
  const {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    id, title, city, _id, company,
  } = { ...job };
  const companyName = company?.name;

  const label = JSON.stringify({
    id,
    title,
    city,
    company: companyName,
  });

  await client.mutate({
    mutation: createAnalyticsEvent,
    variables: {
      title: category,
      type: eventType,
      subjectType: 'Job',
      subjectId: _id,
      payload: label,
      url: getWindowUrl(),
    },
  });

  return true;
};

export default getJobEventTracker;
